import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  TreeSelectionsReducer,
} from './common.js';

export const CategorizeSelectionsReducer = TreeSelectionsReducer;

export const CategorizeSelectionsAggregator = info => {
  const { responses } = info || {};

  return (responses || []).reduce((acc, response) => {
    const { data } = response || {};
    const { answers } = data || {};

    if (!answers || !answers.length) return acc;

    answers.forEach(answer => {
      const { category: categoryId, choices: choicesIds } = answer || {};

      if (!acc[categoryId]) {
        acc[categoryId] = {};
      }

      (choicesIds || []).forEach(choiceId => {
        if (!acc[categoryId][choiceId]) {
          acc[categoryId][choiceId] = { count: 0, value: choiceId };
        }

        acc[categoryId][choiceId].count += 1;
      });
    });

    return acc;
  }, {});
};

export default {
  AggregateMap: GlobalAggregateMap(CategorizeSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(CategorizeSelectionsReducer),
};
